export default "__VITE_ASSET__zYbmFqqM__"